// Backend endpoints.
//
// In production everything is served from a single origin behind Caddy:
//   /grpc/*  -> Envoy (gRPC-Web) -> backend gRPC :9000
//   /api/*   -> backend REST (Fiber) :5000
// In local development the services are reached on their own ports.
const host = typeof window !== 'undefined' ? window.location.hostname : '';
const isLocalDev = host === 'localhost' || host === '127.0.0.1';
const origin = typeof window !== 'undefined' ? window.location.origin : '';
// gRPC-Web endpoint. Browsers cannot speak native gRPC (:9000) — this must
// always point at the gRPC-Web proxy (Envoy), never at the raw gRPC port.
export const API_URL = isLocalDev ? 'http://localhost:9090' : `${origin}/grpc`;
// REST endpoint (Fiber).
export const REST_URL = isLocalDev ? 'http://localhost:5000' : origin;
